module.exports = __webpack_public_path__ + "img/airPurifiers_0.7100e561.png";